import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'member-response-portal',
    templateUrl: './member-response-portal.component.html',
    styleUrls: ['./member-response-portal.component.scss']
})
export class MemberResponsePortalComponent  {
    //#region Inputs, Outputs, ViewChilds
    //#endregion Inputs, Outputs, ViewChilds

    //#region Public Variables
    //#endregion Public Variables

    //#region Private Variables
    //#endregion Private Variables

    //#region Properties
    //#endregion Properties

    //#region Constructor and Angular Life Cycle
    constructor(private titleService: Title,
                public router: Router
    ){
        this.titleService.setTitle('Member Response Portal');
    }
    //#endregion Constructor and Angular Life Cycle

    //#region Event Handlers
    //#endregion Event Handlers

    //#region Public Methods
    public CheckRoutersName(): boolean {
        return this.router.url.includes('survey');
    }
    //#endregion Public Methods

    //#region Private Methods
    //#endregion Private Methods
}
